import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Tax } from '@app/shared/models/tax';
import { TaxService } from '@app/shared/services/taxes/tax.service';
import { BehaviorSubject, Observable } from 'rxjs';

type phases =
  | 'name'
  | 'description'
  | 'id'
  | 'type'
  | 'setup'
  | 'duration'
  | 'calculation'
  | 'value'
  | 'review'
  | 'scope'
  | 'done'
  | '';

@Component({
  standalone: false,
  selector: 'sbnb-settings-taxes',
  templateUrl: './settings-taxes.component.html',
  styleUrls: ['./settings-taxes.component.scss'],
})
export class SettingsTaxesComponent implements OnInit {
  private _tax: BehaviorSubject<Tax> = new BehaviorSubject<Tax>(this.taxService.seedEmptyTax());
  public tax$: Observable<Tax> = this._tax.asObservable();

  allowedRoutes: phases[] = [
    'name',
    'description',
    'id',
    'type',
    'setup',
    'duration',
    'calculation',
    'value',
    'review',
    'scope',
    'done',
  ];

  loading: boolean = false;
  phase = 'name';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private taxService: TaxService
  ) { }

  ngOnInit(): void {
    this.checkRouteIsValid();
    this.checkForTaxToEdit();
  }

  checkRouteIsValid() {
    this.route.params.subscribe((params) => {
      if (this.allowedRoutes.includes(params.path)) {
        this.phase = params.path;
      } else {
        this.router.navigateByUrl('/settings/taxes');
      }
    });
  }

  checkForTaxToEdit() {
    this.route.queryParams.subscribe((params) => {
      if (params.id) {
        this.loading = true;
        this.phaseUpdate('name');

        this.taxService.getTax(params.id).subscribe((tax) => {
          this.loading = false;
          this._tax.next(tax);
        });
      }
    });
  }

  phaseUpdate(newPhase: string) {
    this.phase = newPhase;
    let url = `/settings/taxes/${newPhase}`;

    if (this._tax.getValue().uuid) {
      url += `?id=${this._tax.getValue().uuid}`;
    }

    this.location.replaceState(url);
  }
}
